import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import UserNotificationItem from './UserNotificationItem';
import { useNotificationState } from './NotificationProvider';
import Loader from '../../Components/Utility/Loader/Loader';
import { Page_Size } from '../../Components/helper';
import * as action from './store/notification.action';

function Notification() {
  const reducerState = useSelector((redState) => redState);
  const {
    UserNotificationDetails: { notificationList },
  } = reducerState;
  const { notState, setNotificationState } = useNotificationState();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const handleNextPageInScroll = async () => {
    let pageIndexs = notState?.pageIndex;
    pageIndexs += 1;
    setNotificationState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex: pageIndexs,
      notLoader: true,
    }));
    const params = {
      pageIndex: pageIndexs,
      pageSize: Page_Size,
      isScrolled: true,
    };
    const result = await dispatch(action.fetchNotificationList(params, t));
    if (result) {
      setNotificationState((nextPagestate) => ({
        ...nextPagestate,
        notLoader: false,
      }));
    }
  };

  const toggleItem = (id, event) => {
    event?.stopPropagation();

    let cloneExpandItems = notState?.expandedItems;
    if (cloneExpandItems?.includes(id)) {
      cloneExpandItems = cloneExpandItems?.filter((ids) => ids !== id);
    } else {
      cloneExpandItems = [...cloneExpandItems, id];
    }
    setNotificationState((nextPagestate) => ({
      ...nextPagestate,
      expandedItems: cloneExpandItems,
    }));
  };
  return (
    <div id="scrollableDivNotification" className="notification-list-scroll common-scrollbar">
      <InfiniteScroll
        scrollableTarget="scrollableDivNotification"
        dataLength={notificationList?.length}
        loader={notState?.notLoader && <Loader />}
        hasMore={notState?.hasMore}
        next={handleNextPageInScroll}
      >
        {Array.isArray(notificationList) && notificationList?.length > 0 ? (
          notificationList?.map((notification) => {
            return <UserNotificationItem key={notification?._id} notification={notification} toggleItem={toggleItem} />;
          })
        ) : (
          <p className="text-center mt-4">
            <strong>{t('NOTIFICATION_NOT_FOUND.NOT_FOUND_MESSAGE')}</strong>
          </p>
        )}
      </InfiniteScroll>
    </div>
  );
}

export default Notification;
